import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n/I18nContext';
import './Home.css';

const Home = () => {
  const { t } = useT();
  const extensionDownloadUrl = '/downloads/flashsync-chrome-extension.zip';
  const repositoryUrl = 'https://gitee.com/kobeyoung81/flashsync';

  return (
    <div className="home-page page-shell">
      <div className="container">
        <section className="hero-panel">
          <div className="hero-copy">
            <span className="section-eyebrow">{t('home.eyebrow')}</span>
            <h1>{t('home.heading')}</h1>
            <p className="hero-subtitle">
              {t('home.subtitle')}
            </p>
            <div className="hero-actions">
              <Link to="/register" className="btn btn-primary">
                {t('home.launchVault')}
              </Link>
              <a href={extensionDownloadUrl} className="btn btn-secondary" download>
                {t('home.downloadZip')}
              </a>
              <a href={repositoryUrl} className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                {t('home.viewSource')}
              </a>
            </div>
            <div className="hero-trust-row">
              <div className="trust-card">
                <strong>{t('home.trustZeroKnowledge')}</strong>
                <span>{t('home.trustZeroKnowledgeDesc')}</span>
              </div>
              <div className="trust-card">
                <strong>{t('home.trustImport')}</strong>
                <span>{t('home.trustImportDesc')}</span>
              </div>
              <div className="trust-card">
                <strong>{t('home.trustSelfHosted')}</strong>
                <span>{t('home.trustSelfHostedDesc')}</span>
              </div>
            </div>
          </div>

          <div className="hero-visual surface-card">
            <div className="hero-visual-top">
              <span className="hero-window-dot red" />
              <span className="hero-window-dot yellow" />
              <span className="hero-window-dot green" />
            </div>
            <div className="hero-visual-grid">
              <div className="hero-stat-card hero-stat-primary">
                <span>{t('home.cardVault')}</span>
                <strong>{t('home.cardVaultSub')}</strong>
                <p>{t('home.cardVaultDesc')}</p>
              </div>
              <div className="hero-mini-card">
                <strong>432</strong>
                <span>{t('home.cardBookmarks')}</span>
              </div>
              <div className="hero-mini-card">
                <strong>128</strong>
                <span>{t('home.cardPasswords')}</span>
              </div>
              <div className="hero-mini-card">
                <strong>24/7</strong>
                <span>{t('home.cardControl')}</span>
              </div>
            </div>
          </div>
        </section>

        <section className="home-section">
          <div className="section-heading">
            <span className="section-eyebrow section-eyebrow-dark">{t('home.whyHeading')}</span>
            <h2 className="section-title">{t('home.sharperHeading')}</h2>
            <p className="section-description">
              {t('home.whyBody')}
            </p>
          </div>

          <div className="feature-showcase">
            <article className="feature-showcase-card surface-card">
              <div className="feature-badge">🔐 {t('home.feature1Badge')}</div>
              <h3>{t('home.feature1Heading')}</h3>
              <p>
                {t('home.feature1Body')}
              </p>
            </article>

            <article className="feature-showcase-card surface-card">
              <div className="feature-badge">⚡ {t('home.feature2Badge')}</div>
              <h3>{t('home.feature2Heading')}</h3>
              <p>
                {t('home.feature2Body')}
              </p>
            </article>

            <article className="feature-showcase-card surface-card">
              <div className="feature-badge">📦 {t('home.feature3Badge')}</div>
              <h3>{t('home.feature3Heading')}</h3>
              <p>
                {t('home.feature3Body')}
              </p>
            </article>
          </div>
        </section>

        <section className="home-section">
          <div className="download-card surface-card">
            <div className="download-copy">
              <span className="section-eyebrow section-eyebrow-dark">{t('home.installHeading')}</span>
              <h2>{t('home.installIntroHeading')}</h2>
              <p>
                {t('home.installBody')}
              </p>
              <div className="download-buttons">
                <a href={extensionDownloadUrl} className="btn btn-primary" download>
                  {t('home.downloadBtn')}
                </a>
                <Link to="/register" className="btn btn-secondary">
                  {t('home.createAccount')}
                </Link>
              </div>
            </div>

            <div className="download-steps">
              <h3>{t('home.installInChrome')}</h3>
              <ol>
                <li>{t('home.installStep1')}</li>
                <li>{t('home.installStep2')}</li>
                <li>{t('home.installStep3')}</li>
                <li>{t('home.installStep4')}</li>
              </ol>
            </div>
          </div>
        </section>

        <section className="home-section">
          <div className="cta-panel">
            <div>
              <span className="section-eyebrow">{t('home.ctaHeading')}</span>
              <h2>{t('home.bottomHeading')}</h2>
              <p>
                {t('home.ctaBody')}
              </p>
            </div>
            <div className="cta-actions">
              <Link to="/register" className="btn btn-primary">
                {t('home.startWith')}
              </Link>
              <Link to="/login" className="btn btn-secondary">
                {t('home.existingAccount')}
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;
